export default function debounce (callback, limit = 200) {
  let timeout = setTimeout(callback, limit);

  return () => {
    clearTimeout(timeout);

    timeout = setTimeout(() => {
      callback();
    }, limit);
  };
}
